import cookie from '@s-ui/js/lib/cookie'

import {CONSENT_COOKIE_NAME, DIDOMI_TOKEN_KEY} from './settings.js'

const isClient = typeof window !== 'undefined'

const {remove: removeCookie} = cookie

const rejectAll = () => {
  if (!isClient) return
  window.Didomi.setUserDisagreeToAll()
}

const resetAndCleanCmp = () => {
  if (!isClient) return
  window.Didomi.reset()
  removeCookie(CONSENT_COOKIE_NAME)
  removeCookie(DIDOMI_TOKEN_KEY)
  window.localStorage.removeItem(CONSENT_COOKIE_NAME)
  window.localStorage.removeItem(DIDOMI_TOKEN_KEY)
}

export {rejectAll, resetAndCleanCmp}
